import { render } from "./MobileAccountSubpage.vue?vue&type=template&id=6b8f15e4&scoped=true"
import script from "./MobileAccountSubpage.vue?vue&type=script&lang=js"
export * from "./MobileAccountSubpage.vue?vue&type=script&lang=js"

import "./MobileAccountSubpage.vue?vue&type=style&index=0&id=6b8f15e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8f15e4"]])

export default __exports__